import moment from 'moment';

export const dateFormat = (date: moment.MomentInput) => moment(date).format('DD.MM.YYYY');
export const timeFormat = (time: moment.MomentInput) => moment(time).format('HH:mm');

export const convertFloatToTimeString = (float: number): string => {
  let hours = String(Math.floor(float));
  const minuteDivider = 1 / 60;
  const rest = minuteDivider * Math.round((float - Number(hours)) / minuteDivider);
  let minutes = String(Math.floor(rest * 60));

  if (hours.length < 2) {
    hours = `0${hours}`;
  }

  if (minutes.length < 2) {
    minutes = `0${minutes}`;
  }

  return `${hours}:${minutes}`;
};

// getFormattedDateForAbsence :: DateRange -> DateResult
// DateResult -> DD.MM-DD.MM.YYYY | DD.MM.YYYY
export const getFormattedDateForAbsence = (inputStartDate: string, inputEndDate: string) => {
  const dateCondition = inputStartDate === inputEndDate;
  const year = moment().year();
  const date = inputStartDate + '-' + inputEndDate;
  const hyphenIndex = date.indexOf('-');
  let startDate = inputStartDate;
  const endDate = date.slice(hyphenIndex + 1);

  if (startDate.includes(`.${year}`)) {
    startDate = startDate.replace(`.${year}`, '');
  }

  return dateCondition ? inputStartDate : startDate + '-' + endDate;
};

export const getMonthsRanges = (year: number) => {
  const startDate = moment(`${year}-01-01`, 'YYYY-MM-DD');
  const endDate = moment(`${year}-12-31`, 'YYYY-MM-DD');

  const monthRanges = [];

  let currentMonth = startDate.clone();

  while (currentMonth.isSameOrBefore(endDate)) {
    const startOfMonth = currentMonth.clone().startOf('month').toDate();
    const endOfMonth = currentMonth.clone().endOf('month').toDate();

    monthRanges.push({ start: startOfMonth, end: endOfMonth });
    currentMonth.add(1, 'month');
  }

  return monthRanges;
};
